import {
  Avatar,
  Button,
  Checkbox,
  Chip,
  Container,
  Divider,
  FormControl,
  Grid,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import { withTheme } from '@material-ui/styles';
import clsx from 'clsx';
import { cloneDeep, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import noImg from '../../assets/images/avatar-no-img.png';
import { actions } from '../../redux/actions/actionsHandler';
import { updateUi as updateUiAction } from '../../redux/actions/uiActions';
import { buildLicenseDescription, buildShortLicenseDescription } from '../../util/helpers/other';
import { isModeratorProf } from '../../util/helpers/user';
import { urlDataReader } from '../../util/workers/fileWorkerUtils';
import LoadingButton from '../widgets/LoadingButton';
import { fetchProfileImages as fetchProfileImagesAction } from '../../redux/actions/userActions';
import { getAllFromDividedQuery } from '../../util/helpers/redux';
import cidLogo from '../../assets/images/logo/monograma_cid.png';
import fidLogo from '../../assets/images/logo/monograma_flyid.png';
import LogoTooltip from '../widgets/LogoTooltip';

const styles = ({ container, spacing, palette }) => ({
  container: { ...container(2), marginLeft: 0 },
  innerContainer: {
    ...container(1),
    maxWidth: '850px',
    marginLeft: spacing(2),
  },
  titleContainer: {
    maxWidth: '850px',
  },
  marginBottom: {
    marginBottom: spacing(2),
  },
  button: {
    margin: spacing(2, 0, 2, 0),
  },
  subtitle: {
    margin: spacing(1),
  },
  hidden: {
    display: 'none',
  },
  PaperProps: {
    style: {
      maxHeight: 400,
    },
  },
  profileImage: {
    width: spacing(20),
    height: spacing(20),
  },
  mainGrid: {
    minWidth: '650px',
  },
  sessionMargin: {
    marginTop: spacing(2),
  },
  formControl: {
    margin: spacing(1),
    minWidth: 120,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  authLicensesTitle: {
    color: palette.other.grey.main,
    paddingLeft: spacing(1),
  },
  countidIconRootClass: {
    backgroundColor: palette.primary.main,
  },
  flyidIconRootClass: {
    backgroundColor: palette.primary.dark,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
};

const pilot = 'pilot';
const checker = 'checker';
const assistant = 'assistant';
const moderator = 'moderator';
const permissionsRef = [pilot, checker, assistant, moderator];

const initialState = {
  firstName: '',
  lastName: '',
  employeeId: '',
  permissions: [],
  authDomains: [],
  authLicenses: [],
  email: '',
  profilePicFile: null,
  // UI Flags
  missingPermissions: false,
  missingDomains: false,
  missingLicenses: false,
  showConfirmation: false,
};

const readPermissionsIntoArray = (data) => {
  const permissions = [];
  if (!isEmpty(data)) {
    permissionsRef.forEach((perm) => {
      const permIsGiven = data[perm];
      if (permIsGiven) {
        permissions.push(perm);
      }
    });
  }
  return permissions;
};

class UserProfile extends Component {
  state = { ...initialState, initProfile: false };

  static getDerivedStateFromProps(props, state) {
    const forcedReload = props.location.state && props.location.state.reload;
    const checkProfile = !state.initProfile || forcedReload;

    if (checkProfile) {
      if (forcedReload) {
        props.location.state = null;
      }
      let targetUid = props.match.params.uid;
      let targetProfile;

      // Abscence of targetUid indicates its a own profile change
      const isOwn = isEmpty(targetUid);
      if (isOwn) {
        targetProfile = cloneDeep(props.userProfile);
      } else {
        // if editing someone else's profile, require userProfiles
        let userProfiles = props.userProfiles;
        if (isLoaded(userProfiles) && userProfiles && userProfiles[targetUid]) {
          targetProfile = userProfiles[targetUid];
        } else {
          return null;
        }
      }

      return {
        ...state,
        firstName: targetProfile.firstName,
        lastName: targetProfile.lastName,
        email: targetProfile.email,
        employeeId: targetProfile.employeeId,
        permissions: readPermissionsIntoArray(targetProfile),
        authDomains: targetProfile.authDomains,
        originalData: cloneDeep(targetProfile),
        initProfile: true,
      };
    }
    // Null indicates no state change due to changes in properties
    return null;
  }

  showPasswordResetConfirmation = () => {
    const { firstName, lastName } = this.state.originalData;
    const intl = this.props.intl;
    this.props.updateUi({
      dialog: {
        title: intl.formatMessage({ id: 'prof.pwResetTitle' }),
        message: intl.formatMessage(
          { id: 'prof.pwResetMsg' },
          {
            name: (
              <b key="uob0">
                {firstName} {lastName}
              </b>
            ),
            nl: <br key="upnl0" />,
          }
        ),
        confirmAction: actions.RESET_PASSWORD,
        actionData: {
          uid: this.props.match.params.uid,
        },
        useCheckbox: false,
        show: true,
      },
    });
  };

  handleFileChange = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const file = e.target.files[0];
    if (file) {
      urlDataReader(file, { onload: (result) => this.setState({ profilePicFile: result }) });
    }
  };

  handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const { firstName: origFirstName, lastName: origLastName } = this.state.originalData;
    const { permissions, authDomains } = this.state;

    const isOwn = isEmpty(this.props.match.params.uid);
    const targetUid = isOwn ? this.props.myUid : this.props.match.params.uid;

    const missingDomains = isEmpty(authDomains);
    const missingPermissions = isEmpty(permissions);
    if (missingDomains || missingPermissions) {
      this.setState({ missingDomains, missingPermissions });
      return;
    }

    let data = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      employeeId: this.state.employeeId,
      email: this.state.email,
      profilePicFile: this.state.profilePicFile,
      authDomains,
    };

    permissionsRef.forEach((perm) => {
      data[perm] = permissions.includes(perm);
    });

    const intl = this.props.intl;
    this.props.updateUi({
      dialog: {
        title: intl.formatMessage({ id: 'prof.profChgTitle' }),
        message: intl.formatMessage(
          { id: isOwn ? 'prof.profChgMsgOwn' : 'prof.profChgMsg' },
          {
            name: (
              <b key="upb1">
                {origFirstName} {origLastName}
              </b>
            ),
          }
        ),
        confirmAction: actions.EDIT_USER,
        actionData: {
          uid: targetUid,
          userData: data,
        },
        useCheckbox: false,
        show: true,
      },
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  maybeFetchProfileImage() {
    const { match, myUid, userProfiles, user } = this.props;
    const isOwn = !match.params.uid;
    const targetProfile = userProfiles?.[match.params.uid];

    // Don't fetch own image, since it already happens on NavBar.
    if (!isOwn && targetProfile) {
      const profilePicData = user.profilePics[match.params.uid];
      if (!profilePicData || (!profilePicData.isLoading && !profilePicData.isLoaded)) {
        // Only try to download profile images if properly authenticated
        if (!myUid) return;
        this.props.fetchProfileImages(match.params.uid, targetProfile.company);
      }
    }
  }

  componentDidMount() {
    this.maybeFetchProfileImage();
  }

  componentDidUpdate() {
    this.maybeFetchProfileImage();
  }

  render() {
    const { ui, user, intl, theme, classes, userProfile, userProfiles, match, licensesData, myUid } = this.props;
    let isOwnProfile = !match.params.uid;
    let targetUid = isOwnProfile ? myUid : match.params.uid;
    let targetProfile = userProfile;

    const userIsMod = isModeratorProf(userProfile);
    if (userIsMod && !isOwnProfile) {
      if (isLoaded(userProfiles) && userProfiles[match.params.uid]) {
        targetProfile = userProfiles[match.params.uid];
      }
    }
    const targetIsMod = isModeratorProf(targetProfile);

    const targetProfileLoaded =
      isLoaded(userProfile) && (isOwnProfile || (userProfiles && userProfiles[match.params.uid]));

    let allAuthDomains = targetProfileLoaded
      ? [...new Set(targetProfile.authDomains.concat(userProfile.authDomains))]
      : [];

    let { isLoaded: licensesIsLoaded, data: loadedLicenses } = licensesData;
    let authLicenses = licensesIsLoaded ? loadedLicenses : {};

    const waitOnSkeletonGridRow = (content, ...extraData) =>
      targetProfileLoaded && isLoaded(extraData) ? (
        content
      ) : (
        <Grid item xs={12}>
          <Skeleton variant="rect" height={theme.spacing(5)} animation="wave" />
        </Grid>
      );

    const profileImageData = user.profilePics[targetUid];
    const profileImage = this.state.profilePicFile || (profileImageData && profileImageData.src) || noImg;

    return (
      <Container className={classes.container}>
        <div className={classes.titleContainer}>
          {targetProfileLoaded ? (
            <>
              <Typography variant="h4" style={theme.text.title}>
                {isOwnProfile
                  ? intl.formatMessage({ id: 'prof.myTitle' })
                  : intl.formatMessage(
                      { id: 'prof.title' },
                      { name: `${targetProfile.firstName} ${targetProfile.lastName}` }
                    )}
              </Typography>
              <Typography variant="subtitle1" style={theme.text.subtitle}>
                {isOwnProfile
                  ? intl.formatMessage({ id: 'prof.subtitleOwn' })
                  : intl.formatMessage({ id: 'prof.subtitleMod' })}
              </Typography>
            </>
          ) : (
            <>
              <Skeleton variant="rect" height={theme.spacing(5)} animation="wave" className={classes.marginBottom} />
              <Skeleton variant="rect" height={theme.spacing(3)} animation="wave" className={classes.marginBottom} />
            </>
          )}
        </div>
        <Container className={classes.innerContainer}>
          <form onSubmit={this.handleSubmit}>
            <Grid container spacing={2} className={classes.mainGrid}>
              {/* Profile picture container */}
              <Grid container item spacing={2} direction="column" xs={4} alignItems="center">
                <Grid item>
                  {targetProfileLoaded && profileImageData && profileImageData.isLoaded ? (
                    <Avatar
                      src={profileImage}
                      className={classes.profileImage}
                      alt={intl.formatMessage({ id: 'altUsrProfImage' })}
                    />
                  ) : (
                    <Skeleton
                      variant="circle"
                      className={clsx(classes.profileImage, classes.marginBottom)}
                      animation="wave"
                    />
                  )}
                </Grid>
                <Grid item>
                  {targetProfileLoaded ? (
                    <>
                      <input
                        accept="image/jpeg, image/png"
                        style={{ display: 'none' }}
                        id="profile-image-btn"
                        type="file"
                        onChange={this.handleFileChange}
                      />
                      <label htmlFor="profile-image-btn">
                        <Button variant="contained" component="span" disabled={ui.loadingButton.isEditUserLoading}>
                          {intl.formatMessage({ id: 'prof.chgPicture' })}
                        </Button>
                      </label>
                    </>
                  ) : (
                    <Skeleton variant="rect" height={theme.spacing(5)} width={theme.spacing(20)} animation="wave" />
                  )}
                </Grid>
              </Grid>
              {/* First and last names, id, email, permissions */}
              <Grid container item spacing={2} direction="row" xs={8} alignContent="space-between">
                {/* first and last names */}
                {waitOnSkeletonGridRow(
                  <>
                    <Grid item xs={6}>
                      <TextField
                        disabled={!userIsMod}
                        required
                        fullWidth
                        variant="outlined"
                        id="firstName"
                        name="firstName"
                        type="text"
                        label={intl.formatMessage({ id: 'firstName' })}
                        value={this.state.firstName}
                        onChange={this.handleChange}
                        autoFocus
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        disabled={!userIsMod}
                        required
                        fullWidth
                        variant="outlined"
                        id="lastName"
                        name="lastName"
                        type="text"
                        label={intl.formatMessage({ id: 'lastName' })}
                        value={this.state.lastName}
                        onChange={this.handleChange}
                      />
                    </Grid>
                  </>
                )}
                {/* id and email */}
                {waitOnSkeletonGridRow(
                  <>
                    <Grid item xs={4}>
                      <TextField
                        disabled={!userIsMod}
                        required
                        fullWidth
                        variant="outlined"
                        id="employeeId"
                        name="employeeId"
                        type="text"
                        label={intl.formatMessage({ id: 'employeeId' })}
                        value={this.state.employeeId}
                        onChange={this.handleChange}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <TextField
                        disabled //={!userIsMod}
                        required
                        fullWidth
                        variant="outlined"
                        id="email"
                        name="email"
                        type="email"
                        label={intl.formatMessage({ id: 'email' })}
                        value={this.state.email}
                        onChange={this.handleChange}
                      />
                    </Grid>
                  </>
                )}
                {/* permissions */}
                {waitOnSkeletonGridRow(
                  <Grid item xs={12}>
                    <FormControl fullWidth className={classes.formControl} error={this.state.missingPermissions}>
                      <InputLabel id="permissions-label">{intl.formatMessage({ id: 'permissions' })}</InputLabel>
                      <Select
                        labelId="permissions-label"
                        id="permissions"
                        name="permissions"
                        multiple
                        disabled={!userIsMod}
                        value={this.state.permissions}
                        onChange={this.handleChange}
                        renderValue={(selected) => (
                          <div className={classes.chips}>
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={intl.formatMessage({ id: value })}
                                className={classes.chip}
                                disabled={!userIsMod}
                              />
                            ))}
                          </div>
                        )}
                        onClose={() => {
                          if (this.state.missingPermissions) {
                            this.setState({
                              missingPermissions: isEmpty(this.state.permissions),
                            });
                          }
                        }}
                        MenuProps={MenuProps}
                        input={<Input id="permissions-input" />}
                      >
                        {permissionsRef.map((perm) => (
                          <MenuItem key={perm} value={perm} disabled={perm === moderator}>
                            <Checkbox checked={this.state.permissions.indexOf(perm) > -1} />
                            <ListItemText primary={intl.formatMessage({ id: perm })} />
                            {perm === checker && (
                              <LogoTooltip
                                tooltip={intl.formatMessage({ id: 'grantsCountidAccess' })}
                                logo={cidLogo}
                                iconRootClass={classes.countidIconRootClass}
                              />
                            )}
                            {perm === pilot && (
                              <LogoTooltip
                                tooltip={intl.formatMessage({ id: 'grantsFlyidAccess' })}
                                logo={fidLogo}
                                iconRootClass={classes.flyidIconRootClass}
                              />
                            )}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
              {/* Auth domains */}
              {waitOnSkeletonGridRow(
                <Grid item xs={12} style={{ paddingRight: theme.spacing(5) }}>
                  <FormControl fullWidth className={classes.formControl} error={this.state.missingDomains}>
                    <InputLabel id="authdomains-label">{intl.formatMessage({ id: 'authDomains' })}</InputLabel>
                    <Select
                      labelId="authdomains-label"
                      id="authdomains"
                      name="authDomains"
                      multiple
                      disabled={targetIsMod}
                      value={this.state.authDomains}
                      onChange={this.handleChange}
                      onClose={() => {
                        if (this.state.missingDomains) {
                          this.setState({
                            missingDomains: isEmpty(this.state.authDomains),
                          });
                        }
                      }}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((domain) => (
                            <Chip key={`rend${domain}`} label={domain} className={classes.chip} />
                          ))}
                        </div>
                      )}
                      input={<Input id="authdomains-input" />}
                      MenuProps={MenuProps}
                    >
                      {allAuthDomains &&
                        allAuthDomains.map((domain) => (
                          <MenuItem key={`men${domain}`} value={domain}>
                            <Checkbox checked={this.state.authDomains.indexOf(domain) > -1} />
                            <ListItemText primary={domain} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {/* Licenses */}
              {userIsMod && isOwnProfile && (
                <>
                  <Grid item xs={12} style={{ paddingRight: theme.spacing(5) }}>
                    <Typography className={classes.authLicensesTitle} variant="caption">
                      {intl.formatMessage({ id: 'authLicenses' })}
                    </Typography>
                  </Grid>
                  {waitOnSkeletonGridRow(
                    <>
                      <Grid item xs={12} style={{ paddingRight: theme.spacing(5) }}>
                        <div>
                          {Object.keys(authLicenses).map((lic) => (
                            <Tooltip
                              key={lic}
                              disableTouchListener
                              className={classes.tooltip}
                              title={
                                <Typography variant="h6">
                                  {buildLicenseDescription(authLicenses[lic], lic, intl)}
                                </Typography>
                              }
                            >
                              <Chip
                                label={buildShortLicenseDescription(authLicenses[lic], lic)}
                                className={classes.chip}
                              />
                            </Tooltip>
                          ))}
                        </div>
                      </Grid>
                    </>,
                    authLicenses
                  )}
                </>
              )}
              {/* Divider */}
              <Grid item xs={12} className={classes.sessionMargin}>
                <Divider />
              </Grid>
              {/* Submit button */}
              <Grid container item direction="row" xs={12} justifyContent="space-between">
                <Grid item>
                  <Button
                    component={Link}
                    to={isOwnProfile ? 'changepw' : '#'}
                    onClick={isOwnProfile ? () => {} : this.showPasswordResetConfirmation}
                    disabled={ui.loadingButton.isEditUserLoading}
                    variant="contained"
                    color="primary"
                  >
                    {intl.formatMessage({ id: isOwnProfile ? 'prof.chgPw' : 'prof.rstPw' })}
                  </Button>
                </Grid>
                <Grid item>
                  <LoadingButton
                    isLoading={ui.loadingButton.isEditUserLoading}
                    content={intl.formatMessage({ id: 'saveChanges' })}
                    type="submit"
                  />
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Container>
    );
  }
}

UserProfile.propTypes = {
  myUid: PropTypes.string.isRequired,
  userProfile: PropTypes.object.isRequired,
  updateUi: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired,
};

export default compose(
  connect(
    ({ user, ui, firebase: { auth, profile }, firestore }) => ({
      user,
      myUid: auth.uid,
      userProfile: profile,
      userProfiles: firestore.data.userProfiles,
      licensesData: getAllFromDividedQuery(firestore, 'licenses'),
      ui,
    }),
    (dispatch, ownProps) => ({
      ...ownProps,
      updateUi: (uiData) => dispatch(updateUiAction(uiData)),
      fetchProfileImages: (uid, company) =>
        dispatch(fetchProfileImagesAction({ profileUids: [uid], isThumb: false, company })),
    })
  ),
  withStyles(styles),
  withTheme,
  injectIntl
)(UserProfile);
